import { SharedLegalApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedLegalApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedLegalApi(configuration), [configuration]);
};
